import React from 'react';
import styled from 'styled-components';
import styledNative from 'styled-components/native';
import { Spacer } from '../../Components/SimpleComponents';
import { VerticalCenter } from '../../Components/SimpleLayouts';
import style from '../../Constants/Style';
import AlreadyHaveAccount from './components/AlreadyHaveAccount';
import {
  RegularText,
  VCSText,
  WaffleBackgroundImage,
  WaffleLogoImage,
} from './components/Shared';
import {
  DisplayText,
  StartQuoteViewProps,
} from './components/start-quote.constants';
import StartQuote from './StartQuote';

const WaffleBackgroundLogoContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: 44%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

// justify-content is apparently quirky and prevents overflow from working properly???
const StartQuoteVerticalCenter = styled.div`
  max-height: 100%;
  width: 100%;
  display: flex;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  flex-direction: column;
  align-items: center;
`;

const WaffleBackgroundLogo = styledNative.Image`
  width: 95%;
  height: 90%;
`;

const VerticalCenterContainer = styledNative(VerticalCenter)`
overflow: auto;
`;

const StartQuoteMobileView = (
  props: StartQuoteViewProps
): React.ReactElement => {
  const { client, navigation, productId } = props;
  return (
    <VerticalCenterContainer style={[style.fullWidth, style.fullHeight]}>
      <StartQuoteVerticalCenter>
        <Spacer y={5} />
        <WaffleLogoImage
          style={{ maxWidth: '148px', height: '63px' }}
          source={require('../../../assets/images/Waffle Rebrand 2022 - Full Logo.webp')}
          resizeMode={'contain'}
        />
        <Spacer y={3} />
        <VCSText style={{ fontSize: 40 }}>
          {DisplayText.TheYouInsurance}
        </VCSText>

        <Spacer y={3} />
        <RegularText
          style={{
            fontSize: 18,
            lineHeight: 24,
            maxWidth: '260px',
          }}>
          {DisplayText.EnterYourZip}
        </RegularText>
        <StartQuote
          client={client}
          productId={productId}
          textInputStyle={{ fontSize: 20, height: '41px', width: '269px' }}
          submitBtnStyle={{ height: '43px' }}
          submitBtnTxtStyle={{ fontSize: 19 }}
        />
        <Spacer y={6} />
        <AlreadyHaveAccount
          displayTextStyle={{ fontSize: 14 }}
          signInBtnStyle={{
            width: '269px',
            height: '43px',
          }}
          signInTxtStyle={{ fontSize: 19 }}
          navigation={navigation}
        />
        <Spacer y={8} />
      </StartQuoteVerticalCenter>

      <WaffleBackgroundLogoContainer style={{ backgroundColor: 'black' }}>
        <WaffleBackgroundImage
          source={require('../../../assets/images/Grunge_Waffle_Mobile.webp')}
          resizeMode={'cover'}
        />
        <WaffleBackgroundLogo
          source={require('../../../assets/images/Waffle IconMark - white .svg')}
          resizeMode={'contain'}
        />
      </WaffleBackgroundLogoContainer>
    </VerticalCenterContainer>
  );
};

export default StartQuoteMobileView;
